export default "__VITE_ASSET__SgMGq_2$__"